import { Component,NgModule,Inject } from '@angular/core';
import { ValidationService } from '../interface/UIValidation';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { HttpClient } from '@angular/common/http';
import {
  Router, Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login',
  styleUrls:['./login.component.css'],
  templateUrl: './login.component.html',
})


export class LoginComponent {

  busy: Subscription;
  routing: boolean;
  userModel: LoginModel;
  form: FormGroup;
  constructor(private fb: FormBuilder, private validation: ValidationService, private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string,
    public ngxSmartModalService: NgxSmartModalService,
    private router : Router
  ) {

    this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.routing = true;
          break;
        }
        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.routing = false;
          break;
        }
        default: {
          break;
        }
      }
    });

    sessionStorage["Token"] = "";
    localStorage["RoleList"] = "";
    this.userModel = { userId: '', password: '', isLoggedIn: false, token:'' };
    this.form = fb.group({
      userid: ['', Validators.required],
      password: ['', Validators.required]
    });
 
  }

  submit() {
    var url = this.baseUrl + "api/login/Login";
    this.busy=this.http.post<any>(url, this.userModel).subscribe(res => {
      let result = res;
      if (result) {
        if (result.item1.token && result.item1.isLoggedIn) {
          sessionStorage["Token"] = result.item1.token;
          sessionStorage["UserName"] = result.item1.username;
          localStorage["RoleList"] = result.item2;
          this.router.navigate(['pages']);

        }
        else {
          this.ngxSmartModalService.getModal('confirmationModal').open();
        }
    
      }
  
 
    });
  }

  //test() {
  //  var url = this.baseUrl + "api/login/Login";
  //  this.userModel.token = sessionStorage["Token"];
  //  this.http.post(url, this.userModel).subscribe(res => {
  //    let result = res;

  //  });
  //}


}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts